export default __webpack_public_path__ + "static/soehne-web-leicht-c2cf287e25aa17a80071431b3b0548df.eot";